module.exports = __webpack_public_path__ + "img/AT0000001492337.a1e359f3.png";